import React from 'react';
import { motion } from 'framer-motion';
import { Layers, LayoutGrid, DoorOpen, Settings, Ruler, Hammer } from 'lucide-react';
const services = [{
  icon: Layers,
  title: 'Custom Wood Ceilings',
  description: 'Tongue & groove, slat ceilings, and beam installations that add warmth and character to any room.'
}, {
  icon: LayoutGrid,
  title: 'Feature Walls',
  description: 'Statement walls, wainscoting, and panel systems that transform plain spaces into architectural highlights.'
}, {
  icon: DoorOpen,
  title: 'Interior & Exterior Doors',
  description: 'Expert installation of custom doors, sliders, and entryways with perfect reveals and operation.'
}, {
  icon: Settings,
  title: 'Handles & Hardware',
  description: 'Premium hardware selection and precise installation for the perfect finishing touch.'
}, {
  icon: Ruler,
  title: 'Trim & Baseboards',
  description: 'Clean lines, tight joints, and detailed finish work for baseboards, casing, and crown molding.'
}, {
  icon: Hammer,
  title: 'Custom Installs',
  description: 'High-end custom solutions for luxury homes, remodels, and unique architectural challenges.'
}];
export function ServicesSection() {
  return <section id="services" className="py-24 bg-sunrise-cream relative" data-id="element-170">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-171">
        <div className="text-center mb-16" data-id="element-172">
          <h2 className="font-heading text-4xl md:text-5xl font-bold text-sunrise-charcoal mb-4" data-id="element-173">
            What We Do
          </h2>
          <div className="h-1 w-24 bg-sunrise-orange mx-auto rounded-full" data-id="element-174" />
          <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-175">
            We specialize in the details that turn a house into a custom home.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-176">
          {services.map((service, index) => <motion.div key={service.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white rounded-xl p-8 shadow-lg shadow-sunrise-brown/5 hover:shadow-xl hover:shadow-sunrise-brown/10 hover:-translate-y-1 transition-all duration-300 border border-sunrise-cream-dark" data-id="element-177">
              <div className="w-14 h-14 bg-sunrise-cream rounded-lg flex items-center justify-center mb-6" data-id="element-178">
                <service.icon className="w-8 h-8 text-sunrise-orange" data-id="element-179" />
              </div>
              <h3 className="font-heading text-xl font-bold text-sunrise-charcoal mb-3" data-id="element-180">
                {service.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-181">
                {service.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}